"use strict";

exports.__esModule = true;
exports.default = group;
var _cb = _interopRequireDefault(require("./_cb.js"));
var _each = _interopRequireDefault(require("./each.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// An internal function used for aggregate "group by" operations.
function group(behavior, partition) {
  return function (obj, iteratee, context) {
    var result = partition ? [[], []] : {};
    iteratee = (0, _cb.default)(iteratee, context);
    (0, _each.default)(obj, function (value, index) {
      var key = iteratee(value, index, obj);
      behavior(result, value, key);
    });
    return result;
  };
}